import { PagePermission } from './page.types';

export function anyOf(...codes: string[]): { anyOf: readonly string[] } {
    return { anyOf: codes };
}

export function allOf(...codes: string[]): { allOf: readonly string[] } {
    return { allOf: codes };
}

/** Допуск по структурированному требованию из каталога. */
export function userMeetsPermission(
    permission: PagePermission,
    granted: ReadonlySet<string>,
): boolean {
    if (permission == null) {
        return true;
    }

    if (typeof permission === 'string') {
        return granted.has(permission);
    }

    if ('anyOf' in permission) {
        return permission.anyOf.some((code) => granted.has(code));
    }

    return permission.allOf.length > 0 && permission.allOf.every((code) => granted.has(code));
}
